import { IEnrollment } from "@wingspanhq/benefits/dist/src/lib/interfaces/enrollment";
import { benefitsService } from "./benefitsService";

export const getBenefitsEnrollment = async (
  userId: string
): Promise<IEnrollment> => {
  const { data } = await benefitsService.get(`/enrollment/${userId}`);
  return data;
};
